'use client'
import Link from 'next/link'
import { useState } from 'react'

export default function Navbar() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)
  return (
    <nav 
      className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50" 
      role="navigation" 
      aria-label="Main navigation"
    >
      <div className="py-3 px-4 sm:px-6 lg:px-20">
        <div className="flex items-center md:justify-between">
          {/* Logo and brand */}
          <Link 
            href="/" 
            className="focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md" 
            aria-label="Invoice and Receipt builder - Go to homepage"
          >
            <img key='logo_new_small_compressed.png' src='/logo_new_small_compressed.png' alt='invoice_builder_logo' loading="lazy" className="w-28 md:w-32 h-auto" />
          </Link>

          {/* Navigation Links */}
          <div className='hidden md:flex md:space-x-10'>
                        {/* Explore dropdown */}
                        <div className="relative group">
              <button 
                type="button"
                className="flex items-center space-x-0.5 text-gray-700 hover:text-black px-3 py-2 font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md cursor-pointer"
                aria-expanded="false"
                aria-haspopup="true"
                role="button"
                tabIndex={0}
              >
                <span>Explore</span>
                <svg 
                  className="w-3 h-3 mt-1 text-secondary group-hover:text-black transition-all duration-200 group-hover:rotate-180" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {/* Dropdown menu */}
              <div className="absolute left-0 mt-2 w-56 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible transition-all duration-200 transform translate-y-1 group-hover:translate-y-0 group-focus-within:translate-y-0 z-50">
                <div className="py-2" role="menu" aria-orientation="vertical">
                  <Link 
                    href="/invoice-templates" 
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 focus:outline-none focus:bg-gray-50 focus:text-gray-900" 
                    role="menuitem"
                  >
                    <div className="font-medium">Invoice Templates</div>
                    <div className="text-xs text-gray-500 mt-1">Professional invoice designs</div>
                  </Link>
                  <Link 
                    href="/invoice-generator" 
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 focus:outline-none focus:bg-gray-50 focus:text-gray-900" 
                    role="menuitem"
                  >
                    <div className="font-medium">Invoice Generator</div>
                    <div className="text-xs text-gray-500 mt-1">Create invoices instantly</div>
                  </Link>
                  <Link 
                    href="/freelancer-tools" 
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 focus:outline-none focus:bg-gray-50 focus:text-gray-900" 
                    role="menuitem"
                  >
                    <div className="font-medium">Freelancer Tools</div>
                    <div className="text-xs text-gray-500 mt-1">Resources for freelancers</div>
                  </Link>
                  <Link 
                    href="/small-business-templates" 
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 focus:outline-none focus:bg-gray-50 focus:text-gray-900" 
                    role="menuitem"
                  >
                    <div className="font-medium">Small Business Templates</div>
                    <div className="text-xs text-gray-500 mt-1">Business document templates</div>
                  </Link>
                </div>
              </div>
            </div>
            <Link 
              href="/features" 
              className="text-gray-700 hover:text-black px-3 py-2 font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md"
            >
              Features
            </Link>
            
            {/* Pricing */}
            <Link 
              href="/pricing" 
              className="text-gray-700 hover:text-black px-3 py-2 font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md"
            >
              Pricing
            </Link>

            <div className="relative group">
              <button 
                type="button"
                className="flex items-center space-x-0.5 text-gray-700 hover:text-black px-3 py-2 font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md cursor-pointer"
                aria-expanded="false"
                aria-haspopup="true"
                role="button"
                tabIndex={0}
              >
                <span>Tools</span>
                <svg 
                  className="w-3 h-3 mt-1 text-secondary group-hover:text-black transition-all duration-200 group-hover:rotate-180" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24" 
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {/* Dropdown menu */}
              <div className="absolute left-0 mt-2 w-56 rounded-lg shadow-lg bg-white ring-1 ring-black ring-opacity-5 opacity-0 invisible group-hover:opacity-100 group-hover:visible group-focus-within:opacity-100 group-focus-within:visible transition-all duration-200 transform translate-y-1 group-hover:translate-y-0 group-focus-within:translate-y-0 z-50">
                <div className="py-2" role="menu" aria-orientation="vertical">
                  <Link 
                    href="/invoice-templates" 
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 focus:outline-none focus:bg-gray-50 focus:text-gray-900" 
                    role="menuitem"
                  >
                    <div className="font-medium">Invoice Templates</div>
                    <div className="text-xs text-gray-500 mt-1">Professional invoice designs</div>
                  </Link>
                  <Link 
                    href="/invoice-generator" 
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 focus:outline-none focus:bg-gray-50 focus:text-gray-900" 
                    role="menuitem"
                  >
                    <div className="font-medium">Invoice Generator</div>
                    <div className="text-xs text-gray-500 mt-1">Create invoices instantly</div>
                  </Link>
                  <Link 
                    href="/freelancer-tools" 
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 focus:outline-none focus:bg-gray-50 focus:text-gray-900" 
                    role="menuitem"
                  >
                    <div className="font-medium">Freelancer Tools</div>
                    <div className="text-xs text-gray-500 mt-1">Resources for freelancers</div>
                  </Link>
                  <Link 
                    href="/small-business-templates" 
                    className="block px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 transition-colors duration-150 focus:outline-none focus:bg-gray-50 focus:text-gray-900" 
                    role="menuitem"
                  >
                    <div className="font-medium">Small Business Templates</div>
                    <div className="text-xs text-gray-500 mt-1">Business document templates</div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Link 
            href="/login" 
            className="text-white bg-primary hover:bg-primary-deep px-2 py-1 sm:px-5 sm:py-2 md:font-semibold transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md ml-auto md:ml-0"
          >
            Log in
          </Link>

          {/* Mobile menu */}
          <div onClick={()=> setMobileNavOpen(!mobileNavOpen)} className="md:hidden">
            <div className="text-gray-700 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
              <span className="sr-only">Open main menu</span>
            </div>
          </div>
        </div>
      </div>
      <div className={`md:hidden flex flex-col justify-center items-center transition-all duration-300 ease-in-out transform ${ mobileNavOpen ? 'translate-y-0 opacity-100 py-2' : '-translate-y-full opacity-0 py-0 h-0'} overflow-hidden`}>
        <Link 
          onClick={()=> setMobileNavOpen(false)}
          href="/invoice-generator" 
          className="text-secondary hover:text-black px-3 py-2 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md"
        >
          Create Invoice
        </Link>
        <Link 
          onClick={()=> setMobileNavOpen(false)}
          href="/pricing" 
          className="text-secondary hover:text-black px-3 py-2 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md"
        >
          Pricing
        </Link>
        <Link 
          onClick={()=> setMobileNavOpen(false)}
          href="/invoice-templates" 
          className="text-secondary hover:text-black px-3 py-2 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded-md"
        >
          Invoice Templates
        </Link>
      </div>
    </nav>
  )
}